{
  "aggiornaCarrelloLabel": "Aggiungi al carrello",
  "aggiornaDatiLabel": "Aggiorna Profilo",
  "aggiornamentoLabel": "Aggiornamento...",
  "aggiungiCarrelloLabel": "Aggiungi al carrello",
  "aggiungiNoteLabel": "Aggiungi qui le tue note...",
  "aggiungiPersonaLabel": "Aggiungi persona",
  "aggiuntoLabel": "Aggiunto:",
  "alDateLabel": "A:",
  "alertAppInAggiornamento": "Manutenzione in corso",
  "alertAppInAggiornamentoMess": "Sarà possibile utilizzare l'app al più presto.",
  "alertAppObsoleta": "Versione App Obsoleta",
  "alertAppObsoletaMess": "Aggiornare l'applicazione per continuare ad utilizzarla.",
  "alertDopoLeDodiciLabel": "Dopo le ore 12 è possibile prenotare solo per cena o per i giorni successivi",
  "alertDopoLeUndiciLabel": "è possibile prenotare solo per i giorni successivi",
  "alertDopoLeUndiciLabelStart": "Dopo le ore ",
  "alertDopoLeUndiciMezzeGiornateLabel": " è possibile prenotare solo per il pomeriggio o per i giorni successivi",
  "alertDopoLeVentiLabel": "Dopo le ore 20 è possibile prenotare solo per i giorni successivi",
  "alertError": "Oops! Qualcosa non ha funzionato!",
  "alertErrorMessage": "Riprova :) Se l'errore persiste, prova ad effettuare il logout e riprovare",
  "alertErroreDateLabel": "La data di fine non può essere inferiore a quella di inizio",
  "alertErroreLabel": "Errore sulle date",
  "alertGiorniPassatiLabel": "Non è possibile prenotare per giorni passati",
  "alertLetturaDati": "Lettura dati in corso.",
  "alertMaxOmbrelloni": "È possibile riservare al massimo 5 ombrelloni alla volta.",
  "alertOmbrNonDispLabel": "L'ombrellone selezionato non è più disponibile, sceglierne un altro.",
  "alertPagamentoInCorso": "Pagamento in corso.",
  "alertPrenotaOmbrellone": "Prenotazione Ombrellone",
  "alertPrenotaRistorante": "Prenotazione Ristorante",
  "alertSalvataggioInCorso": "Salvataggio dati in corso.",
  "alertTempoScaduto": "Tempo scaduto per la prenotazione degli ombrelloni riservati: il carrello è stato svuotato.",
  "alertUtentePassErrati": "E-Mail o password errate",
  "alertUtentePassRiprovare": "Verificare i dati immessi e riprovare.",
  "alert_erroreCompletamento": "Errore durante il completamento della prenotazione. Contatta il supporto.",
  "alert_errorePrenotazione": "Errore durante la prenotazione. Riprova.",
  "alert_maxCopertiSlot": "Il numero massimo di coperti per questo slot è",
  "alert_selezionaSlot": "Seleziona uno slot, un tipo di prenotazione e il numero di ospiti",
  "alert_slotNonDisponibile": "Questo slot non è disponibile",
  "annullaAcquistoLabel": "Annulla Acquisto",
  "annullaLabel": "Annulla",
  "annullaLabelTornaIndietro": "Indietro",
  "appUpdateLabel": "Aggiorna App",
  "applePayLabel": "Apple Pay",
  "articoliLabel": "Articoli",
  "barSpiaggiaLabel": "Ordini Spiaggia",
  "bottone_login": "LOGIN",
  "calcoloPrezzoLabel": "Calcolo prezzo in corso...",
  "caniLabel": "Cani",
  "carrelloLabel": "Vai al carrello",
  "carrello_al": "Al",
  "carrello_cani": "Cani",
  "carrello_dal": "Dal",
  "carrello_di": "di",
  "carrello_note": "Note",
  "carrello_ombrelloni": "ombrelloni",
  "carrello_serviziInclusi": "Servizi Inclusi",
  "carrello_tipo": "Tipo",
  "cartaCredito_aggiungiCartaLabel": "Aggiungi carta",
  "cartaCredito_aggiungiCartaPagamentoLabel": "AGGIUNGI O MODIFICA UNA CARTA",
  "cartaCredito_cambiaCartaLabel": "Cambia carta",
  "cartaCredito_cartaLabel": "Carta",
  "cartaCredito_consegnaLabel": "Consegna:",
  "cartaCredito_errorMsgLabel": "Siamo spiacenti, l'ordine non è andato a buon fine.",
  "cartaCredito_esitoPagamentoLabel": "Esito Pagamento",
  "cartaCredito_modificaCartaLabel": "Modifica Carta di Credito",
  "cartaCredito_modificaCartaPagamentoLabel": "Modifica carta di pagamento",
  "cartaCredito_nessunaCartaLabel": "Nessuna carta disponibile",
  "cartaCredito_numeroCartaLabel": "Numero Carta",
  "cartaCredito_ordineCompletatoLabel": "ORDINE COMPLETATO",
  "cartaCredito_ordineMsgLabel": "In caso di prenotazione ombrellone effettuata in contanti è necessario presentarsi entro le ore 12.",
  "cartaCredito_pagaConCartaLabel": "Paga con carta di credito",
  "cartaCredito_pagaOraLabel": "PAGA ORA",
  "cartaCredito_rimuoviCartaLabel": "Rimuovi carta",
  "cartaCredito_ritentaOrdineLabel": "RITENTA ACQUISTO",
  "pagamentoInElaborazioneTitleLabel": "Pagamento in elaborazione",
  "pagamentoInElaborazioneMsgLabel": "Stiamo confermando il tuo pagamento…",
  "pagamentoElaborazioneLungaMsgLabel": "L'elaborazione del tuo ordine sta richiedendo più tempo del previsto. Controlla il Riepilogo ordini e la tua email fra qualche minuto: se l'ordine è presente, il pagamento è andato a buon fine. In caso di dubbi contattaci prima di effettuare un nuovo pagamento.",
  "vaiRiepilogoOrdiniLabel": "Vai al Riepilogo ordini",
  "verificaOrdineTitleLabel": "Verifica dell'ordine in corso",
  "verificaOrdineMsgLabel": "Stiamo verificando lo stato del tuo ordine, attendi qualche secondo…",
  "verificaNonCompletataTitleLabel": "Verifica non completata",
  "verificaOrdineNonConfermatoMsgLabel": "Non siamo riusciti a confermare l'ordine. Controlla il Riepilogo ordini o l'email di conferma: se l'ordine è presente, il pagamento è andato a buon fine. In caso di dubbi contattaci prima di effettuare un nuovo pagamento.",
  "cartaCredito_scadenzaCartaLabel": "Scadenza",
  "cartaCredito_tornaHomeLabel": "TORNA ALLA HOME",
  "cartaCredito_totaleOrdineLabel": "Totale Ordine:",
  "carteAltriMetodiLabel": "Carte e altri metodi",
  "carteAltriMetodiSubtextLabel": "Visa, Mastercard, PayPal, Satispay, Klarna, Amazon Pay...",
  "checkoutCarrelloCartaCreditoLabel": "Carta di Credito",
  "checkoutCarrelloConcludiPagamentoLabel": "Concludi prenotazione",
  "checkoutCarrelloConsegnaOrdineBarLabel": "Come consegnare l'ordine?",
  "checkoutCarrelloConsegnaOrdineMsgLabel": "Inserire dove consegnare l'ordine",
  "checkoutCarrelloContantiLabel": "Contanti",
  "checkoutCarrelloContinuaAcquistiLabel": "Continua acquisti",
  "checkoutCarrelloDataLabel": "Data:",
  "checkoutCarrelloLabel": "Carrello",
  "checkoutCarrelloMetodoPagamentoLabel": "Metodo pagamento",
  "checkoutCarrelloNoPagamentoLabel": "Nessun pagamento richiesto. In caso di imprevisti, contattaci o annulla la prenotazione dal riepilogo ordini, grazie!",
  "checkoutCarrelloNrLettiniLabel": "Numero Lettini:",
  "checkoutCarrelloNrSdraioLabel": "Numero Sdraio:",
  "checkoutCarrelloNumeroPostiRistoranteLabel": "Numero Posti Riservati:",
  "checkoutCarrelloOrarioLabel": "Orario:",
  "checkoutCarrelloOrdineBarLabel": "Paga Ordine",
  "checkoutCarrelloOrdineOmbrelloniTimeoutLabel": "Ordine Ombrelloni",
  "checkoutCarrelloPagaLabel": "Paga",
  "checkoutCarrelloPlaceHolderConsegnaLabel": "Esempio: Ombrellone A11",
  "checkoutCarrelloPrenotatoLabel": "Riservato:",
  "checkoutCarrelloQuandoLabel": "Quando:",
  "checkoutCarrelloRistoranteLabel": "Ordine Ristorante:",
  "checkoutCarrelloSvuotaCarrelloLabel": "Svuota il\tcarrello",
  "checkoutCarrelloTotaleLabel": "Totale:",
  "checkoutCarrelloVuotoAddItemsLabel": "Aggiungi prodotti per iniziare il tuo ordine",
  "checkoutCarrelloVuotoLabel": "Il carrello è vuoto.",
  "chiudiLabel": "Chiudi",
  "ciaoUserLabel": "Ciao",
  "condizioniDiVenditaLabel": "Confermo di aver preso visione delle condizioni di vendita",
  "condizioniVenditaTitleLabel": "Condizioni di vendita",
  "condizioniVenditaReadCtaLabel": "Confermo di aver letto tutto il documento",
  "condizioniVenditaReadDoneLabel": "Lettura confermata",
  "condizioniVenditaReadHintLabel": "Per continuare apri le condizioni di vendita, leggile fino in fondo e conferma.",
  "confermaAzioneLabel": "Conferma Azione",
  "confermaCancellazioneNewsletterLabel": "Sei sicuro di volerti disiscrivere dalla newsletter?",
  "confermaIscrizioneNewsletterLabel": "Vuoi iscriverti alla newsletter per ricevere novità Sunset, eventi e iniziative territoriali collegate?",
  "confermaLabel": "Conferma",
  "confermaOmbrellone_Label": "Conferma la tua prenotazione",
  "confermaRistorante_Label": "Conferma la tua prenotazione",
  "consegnaOmbrelloneLabel": "Consegna all'ombrellone",
  "consenso_privacy_titolo": "Prima di continuare",
  "consenso_privacy_descrizione": "Per accedere con il tuo account social devi prima prendere visione e accettare l'informativa sulla privacy.",
  "contantiLabel": "Contanti",
  "contatti_titolo": "Contatti e Informazioni",
  "continuaLabel": "Continua",
  "cusciniMultipliLabel": "Cuscini",
  "cuscinoSingoloLabel": "Cuscino",
  "daPagareLabel": "Da pagare",
  "dalDateLabel": "Da:",
  "dataLabel": "Data:",
  "dayNamesLabel": "Domenica -, Lunedi -, Martedi -, Mercoledi -, Giovedi -, Venerdi -, Sabato -",
  "dettagliPrenotazioneLabel": "Dettagli Prenotazione",
  "diLabel": "di",
  "disponibilitaLabel": "Disponibilità",
  "elimina_account": "Elimina Account",
  "fasciaOrariaInteraGiornataLabel": "Intera Giornata - 08:00 / 20:00",
  "fasciaOrariaLabel": "Orario?",
  "fasciaOrariaMattinaLabel": "Mattina - 08:00 / 14:00",
  "fasciaOrariaPomeriggioLabel": "Pomeriggio - 14:00 / 20:00",
  "finalitaTrattamento": "Finalità Trattamento Dati",
  "finalita_dati_personali": "Finalità Trattamento Dati",
  "gestRistorante_filtraPerTipo": "Filtra per tipo",
  "gestRistorante_mealTitleCena": "Cena",
  "gestRistorante_mealTitlePranzo": "Pranzo",
  "gestRistorante_selezionaData": "Seleziona data",
  "gestRistorante_tutti": "Tutti",
  "gestRistorante_vistaConfigurazioneSlot": "Configurazione Slot",
  "gestRistorante_vistaPrenotazioni": "Prenotazioni",
  "giornataLabel": "Intera Giornata",
  "giorniLabel": "Giorni",
  "giorniMultipliLabel": "Prenota Giorni Multipli",
  "giorniPrenotatiLabel": "Nr. Giorni:",
  "googlePayLabel": "Google Pay",
  "homeCena": "Cena",
  "homeNumeroCoperti": "Numero di coperti?",
  "homePranzo": "Pranzo",
  "homePranzoOCena": "Vuoi prenotare a pranzo o cena?",
  "homePrenotaLabel": "Prenota",
  "homeScegliNumeroCoperti": "Scegliere il numero di coperti",
  "homeSelezionaOrario": "Seleziona l'orario",
  "homeSelezionaOrarioMsg": "Per favore scegliere un orario",
  "homeServizioBar": "Il servizio bar sarà attivato a breve.",
  "home_dataDifferente": "Scegliere una data differente",
  "home_dayNames": "Dom -, Lun -, Mar -, Mer -, Gio -, Ven -, Sab -",
  "home_disponibiliLabel": "Disponibili:",
  "home_monthShortNames": "Gen, Feb, Mar, Apr, Mag, Giu, Lug, Ago, Set, Ott, Nov, Dic",
  "home_postiLabel": "Posti",
  "home_prenotaOmbrellone": "Prenota un ombrellone",
  "home_prenotaRistorante": "Prenota ristorante",
  "home_prenotaOnline": "Prenota Online",
  "home_ristoranteLabel": "RISTORANTE",
  "home_selezionaGiorno": "Che Giorno?",
  "iTuoiOrdiniLabel": "I tuoi ordini",
  "importoMinimoLabel": "per ordine minimo",
  "importoMinimoMancanoLabel": "Mancano",
  "importoMinimoNonRaggiuntoLabel": "Importo minimo non raggiunto",
  "importoMinimoPerIlBarLabel": "€ per il bar",
  "inGestioneLabel": "IN GESTIONE",
  "infoAccessLabel": "Accessibilità",
  "infoComunicazioniLabel": "Per comunicazioni e segnalazioni, scrivere a beachclubsrl@gmail.com",
  "infoCusciniLabel": "Cuscini",
  "infoDocceLabel": "Docce",
  "infoFilaLabel": "Fila",
  "infoLabel": "Info",
  "infoParcheggioLabel": "Parcheggio",
  "infoPrezziLabel": "Prezzi",
  "infoRistoranteLabel": "Ristorante",
  "infoServiziLabel": "I nostri servizi",
  "infonNoleggioLabel": "Noleggio Sup e canoe",
  "informazioniContattoLabel": "Informazioni di Contatto",
  "informazioniPersonaliLabel": "Informazioni Personali",
  "inserisciDatiLabel": "Prenota un ombrellone:",
  "insertName": "Inserire il proprio nome",
  "insertSurname": "Inserire il proprio cognome",
  "invalidPhone": "Lunghezza errata: cellulare non valido.",
  "label_email": "Email",
  "label_ombrellone_generico": "Ombrellone",
  "label_password": "Password",
  "lettiniMultipliLabel": "Lettini",
  "lettinoAggiuntivoLabel": "Lettino aggiuntivo",
  "lettinoLabel": "LETTINO",
  "lettinoSingoloLabel": "Lettino",
  "listaCommensaliLabel": "Lista Commensali",
  "listaOrdiniLabel": "Ordini",
  "logout_annulla": "Annulla",
  "logout_esci": "Esci",
  "logout_header": "Conferma Logout",
  "logout_message": "Sei sicuro di voler uscire?",
  "lunghMaxDodCar": "Lunghezza massima 12 caratteri",
  "lunghMaxVentiCar": "Lunghezza massima 20 caratteri",
  "lunghMaxVentiCinqueCar": "Lunghezza massima 25 caratteri",
  "lunghMinDueCar": "Lunghezza minima 2 caratteri",
  "lunghMinSeiCar": "Lunghezza minima 6 caratteri",
  "lunghMinTreCar": "Lunghezza minima 3 caratteri",
  "mainPageBarRistoranteLabel": "Ristorante-Bar",
  "mainPageOmbrelloniLabel": "Ombrelloni",
  "mancanoLabel": "Mancano",
  "mattinaLabel": "Mattina",
  "maxPostiPren": "Numero massimo posti prenotabili:",
  "mbrelloniTitleLabel": "Ombrelloni",
  "menuPubblicoChiudiLabel": "CHIUDI",
  "modificaProfiloLabel": "Modifica Profilo",
  "modificaRicercaLabel": "Modifica Ricerca",
  "monthLongNames": "Gennaio, Febbraio, Marzo, Aprile, Maggio, Giugno, Luglio, Agosto, Settembre, Ottobre, Novembre, Dicembre",
  "nessunElementoTrovatoLabel": "Nessun elemento trovato",
  "nessunOrdineDescLabel": "Non hai ancora effettuato nessun ordine",
  "nessunOrdineLabel": "Nessun ordine presente",
  "nessunPostoDisponibileLabel": "Nessun posto disponibile nella fascia oraria selezionata",
  "nessunoLabel": "NESSUNO",
  "newsletterLabel": "Newsletter",
  "newsletterNotSubscribedLabel": "Novità Sunset, eventi e iniziative territoriali",
  "newsletterSubscribedLabel": "Sei iscritto alla nostra newsletter",
  "nienteSdraioLabel": "Non ci sono sdraio disponibili.",
  "noPrenotaSoloOmbrelloneLabel": "PRENOTA SOLO OMBRELLONE",
  "noPrenotaSoloRistoranteLabel": "PRENOTA SOLO RISTORANTE",
  "nonProntoLabel": "NON PRONTO",
  "noteAggiuntiveLabel": "Note aggiuntive",
  "noteLabel": "Note",
  "noteLabelGeneric": "Note:",
  "numMaxOmbrelloniPrenotabiliLabel": "Non è possibile aggiungere al carrello altri ombrelloni, numero massimo per utente:",
  "numeroCopertiLabel": "Numero Coperti:",
  "numeroLettiniLabel": "Numero di lettini:",
  "numeroMassimoGgPrenotabili": "Numero massimo di giorni prenotabili",
  "numeroPrenotazioneLabel": "N. Prenotazione",
  "numeroSdraioLabel": "Numero di sdraio:",
  "numeroSeduteLabel": "Numero di sedute",
  "numeroServiziAggLabel": "Numero servizi aggiuntivi:",
  "obbligoDueSdraioLabel": "È obbligatorio prenotare almeno 2 sdraio.",
  "obbligoUnaSdraioLabel": "È obbligatorio prenotare almeno 1 sdraio.",
  "okPrenotaAncheOmbrelloneLabel": "SI, PRENOTA OMBRELLONE",
  "okPrenotaAncheRistoranteLabel": "SI, PRENOTA RISTORANTE",
  "ombrelloneLabel": "Ombrellone",
  "ombrellone_disponibile": "Disponibile",
  "ombrelloniLabel": "ombrelloni",
  "ombrelloniSelezionatiLabel": "Ombrelloni Selezionati",
  "onlineLabel": "ONLINE",
  "onlyLetters": "Inserire solo lettere",
  "onlyNumbers": "Inserire solo numeri",
  "ordineBarTitleLabel": "Ordini Bar",
  "ordineEffettuatoLabel": "Ordine Effetuato",
  "ordineInGestioneLabel": "Ordine in gestione",
  "ordineLabel": "Ordine",
  "ordineNonProntoLabel": "Ordine non ancora pronto",
  "ordineNrLabel": "Ordine N.",
  "ordineProntoLabel": "Ordine pronto",
  "ordine_generico": "Ordine",
  "pagamentoOnlineLabel": "Pagamento Online",
  "pagatoLabel": "Pagato",
  "payPalLabel": "PayPal",
  "periodoSelezionatoLabel": "Periodo Selezionato",
  "placeholder_cerca": "Cerca...",
  "placeholder_cognomeField": "Cognome",
  "placeholder_confermaPassword": "Conferma la nuova password",
  "placeholder_emailField": "Email",
  "placeholder_inserisciCognome": "Inserisci il tuo cognome",
  "placeholder_inserisciEmail": "Inserisci la tua email",
  "placeholder_inserisciNome": "Inserisci il tuo nome",
  "placeholder_inserisciNumero": "Inserisci il tuo numero",
  "placeholder_inserisciNuovaPassword": "Inserisci la nuova password",
  "placeholder_inserisciPassword": "Inserisci la tua password",
  "placeholder_nomeField": "Nome",
  "placeholder_notePrenotazione": "Aggiungi eventuali note per la prenotazione...",
  "placeholder_orario": "HH:MM",
  "placeholder_selezionaCoperti": "Seleziona coperti",
  "placeholder_telefonoField": "Telefono",
  "pomeriggioLabel": "Pomeriggio",
  "posizioneLabel": "Posizione:",
  "postiDisp": "Non sono rimasti posti disponibili.",
  "pranzoCena": "Pranzo o Cena?",
  "prenotaAncheOmbrelloneLabel": "Vuoi prenotare un ombrellone per lo stesso giorno?",
  "prenotaAncheRistoranteLabel": "Vuoi prenotare un posto al ristorante per lo stesso giorno?",
  "prenotaAsportoLabel": "Food delivery & Take Away",
  "prenotaPostoLabel": "Riserva un ombrellone",
  "prenotaTabBar": "Prenota",
  "prenotazioneRistorante": "Prenotazione Ristorante",
  "procediCheckoutLabel": "Procedi al Checkout",
  "profilo_personale": "Profilo Personale",
  "prontoLabel": "PRONTO",
  "proseguiGuestLabel": "Procedi come ospite",
  "proseguiGuestOppure": "Oppure",
  "recuperoOrdini": "Recupero dei tuoi ordini in corso",
  "resetPass_cambiaPassword": "Modifica Password",
  "resetPass_confermaCambioLabel": "Riceverai una email di conferma all'indirizzo indicato",
  "resetPass_diversePassword": "Le password inserite sono diverse",
  "resetPass_emailNonValida": "Indirizzo E-Mail non valido",
  "resetPass_inserireMail": "Per favore inserire la propria e-mail",
  "resetPass_inserirePassword": "Per favore inserire una password",
  "resetPass_inserisciDatiLabel": "Inserisci il tuo indirizzo email e scegli una nuova password",
  "resetPass_modificaLabel": "Modifica la tua password",
  "resetPass_msgConfermaLabel": "Clicca sulla e-mail di conferma per accedere con la nuova password",
  "resetPass_reinserirePassword": "Per favore ridigitare la password",
  "resetPass_riscriviLabel": "Riscrivi",
  "resetPass_spamLabel": "(Controllare la posta indesiderata)",
  "riepilogoOrdiniLabel": "Riepilogo Ordini",
  "rimossoLabel": "Rimosso:",
  "riprovaLabel": "Riprova",
  "risparmioLabel": "Risparmio",
  "ristoranteLabel": "Ristorante",
  "ristoranteTitleLabel": "Ristorante",
  "ristorante_caratteri": "caratteri",
  "ristorante_confermaLabel": "Conferma Prenotazione",
  "ristorante_confermaPrenotazione": "Conferma Prenotazione",
  "ristorante_coperti": "coperti",
  "ristorante_dataPrenotazione": "Data prenotazione",
  "ristorante_disponibile": "Disponibile",
  "ristorante_disponibiliLabel": "Disponibili:",
  "ristorante_ilPranzo": "il pranzo",
  "ristorante_laCena": "la cena",
  "ristorante_maxCoperti": "Max",
  "ristorante_messaggioDopo1200": "Dopo le 12:00 è possibile prenotare solo per la cena o per altri giorni.",
  "ristorante_messaggioDopo1930": "Dopo le 19:30 è possibile prenotare solo dal giorno successivo.",
  "ristorante_nessunOrario": "Nessun orario disponibile per",
  "ristorante_nonDisponibile": "Non Disponibile",
  "ristorante_servizioNonDisponibile": "Il servizio non è al momento disponibile",
  "ristorante_noteOpzionali": "Note aggiuntive (opzionale)",
  "ristorante_numeroCoperti": "Numero coperti",
  "ristorante_orariDisponibili": "Orari disponibili",
  "ristorante_persone": "persone",
  "ristorante_postiLabel": "Posti",
  "ristorante_prenotaAltraData": "Prenota per un'altra data",
  "ristorante_scegliPranzoOCena": "Scegli pranzo o cena per vedere gli orari disponibili.",
  "ristorante_sceltaFasciaOraria": "Scegli la fascia oraria",
  "ristorante_selezionaFascia": "Seleziona una fascia oraria",
  "ristorante_tipoPrenotazione": "Seleziona il tipo di prenotazione",
  "ritiroAlChioscoLabel": "Ritiro al bar",
  "scegliDataLabel": "Per favore scegliere una data",
  "scegliOmbrelloLabel": "Scegli un Ombrellone",
  "scorriPerAggiornareLabel": "Scorri per aggiornare",
  "sdraioAggLabel": "SDRAIO",
  "sdraioAggiuntivaLabel": "Sdraio aggiuntiva",
  "sdraioLabel": "Sdraio:",
  "sdraioMultipleLabel": "Sdraio",
  "sdraioSingolaLabel": "Sdraio",
  "seduteAggLabel": "SEDUTE AGGIUNTIVE",
  "sezione_contatti": "Contatti",
  "sezione_informazioniPersonali": "Informazioni Personali",
  "sezione_privacy": "Privacy",
  "sezione_sicurezza": "Sicurezza",
  "signup_account": "Creazione Account",
  "signup_cognome": "Cognome",
  "signup_completaRegistrazione": "Completa Registrazione",
  "signup_emailNonValida": "Indirizzo E-Mail non valido",
  "signup_inserireMail": "Per favore inserire la propria e-mail",
  "signup_inserirePassword": "Per favore inserire una password",
  "signup_inserireTelefono": "Inserire il proprio numero di telefono",
  "signup_nome": "Nome",
  "signup_presoVisioneInformativa": "Dichiaro di aver preso visione dell'informativa <br>sul Trattamento dei dati personali",
  "signup_presoVisioneTrattamento": "Dichiaro di aver preso visione dell'informativa <br>sulla Finalità del trattamento",
  "signup_telefono": "Telefono",
  "stagioneTerminataLabel": "stagione terminata",
  "statoLabel": "Stato",
  "tipoLabel": "Tipo",
  "tipoPasto_cena": "Cena",
  "tipoPasto_nonSpecificato": "Non specificato",
  "tipoPasto_pizzeria": "Pizzeria",
  "tipoPasto_pranzo": "Pranzo",
  "tipoPasto_ristorante": "Ristorante",
  "tipoPasto_ristoranteOPizzeria": "Ristorante o pizzeria",
  "tipoPasto_ristorantePizzeria": "Ristorante e Pizzeria",
  "tipoPasto_soloPizzeria": "Solo Pizzeria",
  "tipoPasto_soloRistorante": "Solo Ristorante",
  "totaleParzialeLabel": "Totale:",
  "totalePrenotazioneLabel": "Totale Prenotazione",
  "trattamento_dati_personali": "Trattamento Dati Personali",
  "trattametoDati": "Trattamento Dati Personali",
  "tutorial_avanti": "Avanti",
  "tutorial_benvenuto": "Benvenuto!",
  "tutorial_indietro": "Indietro",
  "tutorial_inizia": "Inizia",
  "tutorial_salta": "Salta",
  "tutorial_slide1": "Benvenuto su Sunset Beach App! Scopri come prenotare il tuo ombrellone in pochi semplici passi.",
  "tutorial_slide2": "Scegli se prenotare un ombrellone o il ristorante.",
  "tutorial_slide3": "Seleziona le date del tuo soggiorno e visualizza la disponibilità degli ombrelloni.",
  "tutorial_slide4": "Seleziona il tuo ombrellone preferito sulla mappa della spiaggia.",
  "tutorial_slide5": "Visualizza i dettagli e il totale e conferma! Se hai esigenze particolari, ricordati di segnare tutto nelle note",
  "tutorial_slide6": "Scegli il metodo di pagamento e concludi la prenotazione.",
  "tutorial_slide7": "Tutto fatto! Benvenuti al Sunset Beach Club!",
  "tutorial_slide8": "Per prenotare il ristorante seleziona una fascia oraria, pranzo o cena e l'orario che preferisci. Basta un click!",
  "tutorial_slide9": "Rivedi il riepilogo dei tuoi ordini dalla sezione 'Riepilogo' nella pagina principale",
  "vaiAlCarrelloLabel": "Vai al carrello",
  "warningMessageLabel": "Per visualizzare la webcam, premere play, spostare l'indicatore di avanzamento in avanti e ripremere play, lo streaming partirà dopo qualche secondo",
  "welcome_costaViola": "Costa Viola",
  "welcome_emailNonValida": "Indirizzo E-Mail non valido",
  "welcome_fbLogin": "Facebook Login",
  "welcome_info": "Info",
  "welcome_inserireMail": "Per favore inserire la propria e-mail",
  "welcome_inserirePassword": "Per favore inserire una password",
  "welcome_nonHaiAccount": "Non hai un account?",
  "welcome_oppure": "OPPURE",
  "welcome_passDimenticata": "Hai dimenticato la password?",
  "welcome_registrati": "Registrati",
  "welcome_titolo": "Benvenuti in",
  "tuttiLabel": "Tutti",
  "verificaDispLabel": "CERCA UN OMBRELLONE",
  "logout_bottone": "LOGOUT",
  "eliminaAccountTitolo": "Elimina Account",
  "eliminaAccountMessaggio": "Sei sicuro di voler eliminare il tuo account?",
  "eliminaPrenotazioneTitolo": "Elimina Prenotazione",
  "eliminaPrenotazioneMessaggio": "Sei sicuro di voler eliminare la prenotazione",
  "prenotaSubitoLabel": "PRENOTA SUBITO",
  "barPageTitle": "Sunset Beach Bar",
  "barChiusoLabel": "Il bar è attualmente chiuso",
  "totaleLabel": "Totale",
  "perMinimoLabel": "per il minimo",
  "ordineMinNonRaggiuntoLabel": "ORDINE MINIMO NON RAGGIUNTO",
  "barLabel": "BAR",
  "completaDatiTitolo": "Completa i tuoi dati",
  "privacyTitolo": "Privacy",
  "nuovaPasswordTitolo": "Nuova Password",
  "linguaLanguageLabel": "Lingua / Language",
  "devModeLabel": "DEV MODE",
  "oopsLabel": "Oops!",
  "loadingLabel": "Caricamento...",
  "contattiTitolo": "Contatti e Informazioni",
  "finalitaDatiTitolo": "FINALITÀ TRATTAMENTO DATI",
  "trattamentoDatiTitolo": "TRATTAMENTO DATI",
  "menuLabel": "Menu",
  "infoBarPausaLabel": "Metti in pausa i messaggi",
  "infoBarRiprendiLabel": "Riprendi i messaggi",
  "infoBarSuccessivoLabel": "Messaggio successivo",
  "alertConnessioneTitolo": "Nessuna connessione",
  "alertConnessioneMessaggio": "Non riusciamo a raggiungere il server. Controlla la connessione a internet e riprova.",
  "erroreAccountEsistente": "Questa email è già registrata. Accedi oppure recupera la password.",
  "erroreDatiRegistrazione": "Alcuni dati non sono validi. Controlla i campi e riprova.",
  "erroreRecuperoEmailSconosciuta": "Non troviamo un account con questa email. Controlla l'indirizzo o registrati.",
  "erroreRecuperoAccountSocial": "Questo account usa l'accesso con Google, Facebook o Apple: la password non si cambia da qui.",
  "whatsappScriviciLabel": "Scrivici su WhatsApp",
  "whatsappAvvisoMessaggio": "Ti risponde lo staff del Sunset Beach Club, dalle 8 alle 20. Nei giorni più pieni potrebbe volerci un po' di più: ti rispondiamo appena possibile.",
  "whatsappApriLabel": "Apri WhatsApp",
  "whatsappMessaggioOspite": "Ciao Sunset Beach! ",
  "whatsappMessaggioUtente": "Ciao Sunset Beach! Sono {{nome}}. ",
  "infoAccessibilitaTitolo": "Accessibilità al Sunset Beach Club",
  "infoAccessibilitaIntro": "Se ti muovi in carrozzina o con qualche difficoltà, ecco come è organizzato il lido.",
  "infoAccessibilitaPercorsiTitolo": "Percorsi e servizi",
  "infoAccessibilitaVoce1": "Passerelle dall'ingresso fino alla riva",
  "infoAccessibilitaVoce2": "Bar e ristorante senza gradini, con pedane per carrozzina",
  "infoAccessibilitaVoce3": "Bagni e docce accessibili",
  "infoAccessibilitaVoce4": "Sedia JOB per fare il bagno in mare",
  "infoAccessibilitaPostazioniTitolo": "Dove prenotare",
  "infoAccessibilitaPostazioni": "Le postazioni più comode sono quelle in prima fila e i gazebo.",
  "infoAccessibilitaNota": "Ti serve qualcosa in particolare? Contattaci prima di arrivare e ci organizziamo.",
  "infoGravidanzaTitolo": "Al mare in dolce attesa",
  "infoGravidanzaIntro": "Qualche suggerimento per scegliere la postazione più comoda.",
  "infoGravidanzaConsigliTitolo": "Cosa ti consigliamo",
  "infoGravidanzaVoce1": "Un gazebo: più ombra e più spazio intorno a te",
  "infoGravidanzaVoce2": "Una postazione in prima fila, vicino al mare",
  "infoGravidanzaNota": "Le sedute incluse nella postazione non si possono aggiungere né togliere: prima di prenotare controlla nella scheda i servizi inclusi.",
  "infoAccessibilitaMenu": "Accessibilità",
  "infoGravidanzaMenu": "In gravidanza",
  "signup_completa_messDati": "Per poter procedere è necessario inserire <br> tutti i dati richiesti.",
  "completaPagamentoTitolo": "Completa il pagamento",
  "pagamentoCartaNonDisponibile": "Il pagamento con carta non si è caricato. Chiudi la finestra e riprova.",
  "pagamentoCartaNonRiuscito": "Pagamento non riuscito. Riprova.",
  "virtualTourMenu": "Tour virtuale"
}